// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "modules/" + chunkId + "." + "df82d84375ccc794f75b" + ".js";
};